import {
  EExaLightIsAutoTest,
  EExaLightModulationMode,
  EExaLightModulationOrigin,
  EExaLightRelayState,
} from "@/types/backoffice/dto/odity-extended/odity-extended-modulator-exact-dto.ts";

const modulationMode: Record<EExaLightModulationMode, string> = {
  [EExaLightModulationMode.COMFORT_PASS_THROUGH]: "Copie du signal entrant / confort",
  [EExaLightModulationMode.STOP]: "Arrêt",
  [EExaLightModulationMode.FROST_GUARD]: "Hors-Gel",
  [EExaLightModulationMode.ECO]: "Éco",
  [EExaLightModulationMode.COMFORT]: "Confort",
  [EExaLightModulationMode.COMFORT_1]: "Confort -1°C",
  [EExaLightModulationMode.COMFORT_2]: "Confort -2°C",
  [EExaLightModulationMode.NO_MODULATION]: "No active modulation",
  [EExaLightModulationMode.FAILED_BACKEND]: "Server Internal Error",
  [EExaLightModulationMode.ON]: "Marche",
  [EExaLightModulationMode.TEMPERATURE]: "Température",
};

const livevxLocale = {
  livevx: {
    realtimeControlMonitoring: "Suivi du pilotage",
    title: "Temps réel",
    isProcessing: "En cours",
    stopped: "Arrêt",
    roomChoice: "Sélectionner une pièce",
    audit: "Actualiser",
    resultModulation: "Consignes appliquées par le dispositif ...",
    noModulation: "Aucun",
    noConsoleDiag: "Impossible de récupérer les autres informations : Pas de réponse du module",
    timeSlotFrom: "Plage horaire du pilotage du",
    timeSlotTo: "au",
    modulationProcessing: "Consigne sauvegardée dans le module de communication:",
    originModulation: "Type du pilotage :",
    relayState: "Relais :",
    wireCommandMode: "Signal fil pilote envoyé par le modulateur:",
    autoTesting: "Test auto activé :",
    resultPower: "Consommation (3 mesures) ...",
    measuredPower: "Puissance instantanée mesurée à",
    noMeasures: "Impossible de récupérer les données de puissance : pas de réponse du module",
    relay: {
      [EExaLightRelayState.OPEN]: "Ouvert",
      [EExaLightRelayState.CLOSED]: "Fermé",
      [EExaLightRelayState.UNKNOWN]: "Erreur",
      [EExaLightRelayState.IS_NOT_A_RELAY]: "Erreur",
    },
    autoTestingState: {
      [EExaLightIsAutoTest.TRUE]: "Oui",
      [EExaLightIsAutoTest.FALSE]: "Non",
      [EExaLightIsAutoTest.NO_INFO]: "Erreur",
    },
    modulationOrigin: {
      [EExaLightModulationOrigin.UNKNOWN]: "Origine inconnue",
      [EExaLightModulationOrigin.PRODUCTION]: "Modulation Voltalis",
      [EExaLightModulationOrigin.SSY]: "Modulation Voltalis (Service Système)",
      [EExaLightModulationOrigin.SUBSCRIBER_TEMPERATURE]: "Pilotage en température",
      [EExaLightModulationOrigin.SUBSCRIBER_ON_OFF]: "Programme de chauffe ON/OFF",
      [EExaLightModulationOrigin.SUBSCRIBER_ABSENCE]: "Pilotage manuel ou mode rapide",
      [EExaLightModulationOrigin.SUBSCRIBER_HEATER]: "Programme de chauffe hebdomadaire",
      [EExaLightModulationOrigin.FAILED_BACKEND]: "Erreur serveur",
    },
    modulationMode,
    history: {
      title: "Historique",
      power: "Consommation : {power} W",
      weekly: "Hebdomadaire : {isWeekly}",
      yes: "Oui",
      no: "Non",
      mode: "Mode :",
      start: "Début : {start}",
      end: "Fin : {end}",
    },
    exactModulationMode: {
      [EExaLightModulationMode.ON]: "Marche",
      [EExaLightModulationMode.STOP]: "Arrêt",
      [EExaLightModulationMode.ECO]: "Eco",
      [EExaLightModulationMode.FROST_GUARD]: "Hors-gel",
      [EExaLightModulationMode.COMFORT]: "Confort",
      [EExaLightModulationMode.COMFORT_PASS_THROUGH]: "Confort pass through",
      [EExaLightModulationMode.TEMPERATURE]: "Température",
    },
  },
};

export type LivevxLocale = typeof livevxLocale;
export default livevxLocale;
